import type { Template } from "@/types";

export const LA_07_H0_V7: Template[] = [
    {
        id: "la-07-h0v7-01",
        name: "LA 01 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_01.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 118, y: 58, width: 141, height: 208, rotation: 0, imageRotation: 0 },
            { id: "2", x: 118, y: 274, width: 141, height: 208, rotation: 0, imageRotation: 0 },
            { id: "3", x: 267, y: 58, width: 141, height: 208, rotation: 0, imageRotation: 0 },
            { id: "4", x: 267, y: 274, width: 141, height: 208, rotation: 0, imageRotation: 0 },
            { id: "5", x: 416, y: 58, width: 142, height: 208, rotation: 0, imageRotation: 0 },
            { id: "6", x: 416, y: 274, width: 142, height: 208, rotation: 0, imageRotation: 0 },
            { id: "7", x: 873, y: 58, width: 294, height: 425, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h0v7-02",
        name: "LA 02 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_02.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 143, y: 0, width: 390, height: 541, rotation: 0, imageRotation: 0 },
            { id: "2", x: 794, y: 58, width: 142, height: 208, rotation: 0, imageRotation: 0 },
            { id: "3", x: 944, y: 58, width: 141, height: 208, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1093, y: 58, width: 141, height: 208, rotation: 0, imageRotation: 0 },
            { id: "5", x: 794, y: 274, width: 142, height: 208, rotation: 0, imageRotation: 0 },
            { id: "6", x: 944, y: 274, width: 141, height: 208, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1093, y: 274, width: 141, height: 208, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h0v7-03",
        name: "LA 03 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_03.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 117, y: 38, width: 292, height: 464, rotation: 0, imageRotation: 0 },
            { id: "2", x: 417, y: 38, width: 142, height: 228, rotation: 0, imageRotation: 0 },
            { id: "3", x: 417, y: 274, width: 142, height: 228, rotation: 0, imageRotation: 0 },
            { id: "4", x: 851, y: 38, width: 159, height: 228, rotation: 0, imageRotation: 0 },
            { id: "5", x: 851, y: 274, width: 159, height: 228, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 38, width: 159, height: 228, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1018, y: 274, width: 159, height: 228, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h0v7-04",
        name: "LA 04 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_04.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 177, y: 38, width: 158, height: 229, rotation: 0, imageRotation: 0 },
            { id: "2", x: 177, y: 275, width: 158, height: 228, rotation: 0, imageRotation: 0 },
            { id: "3", x: 343, y: 38, width: 157, height: 229, rotation: 0, imageRotation: 0 },
            { id: "4", x: 343, y: 275, width: 157, height: 228, rotation: 0, imageRotation: 0 },
            { id: "5", x: 793, y: 38, width: 292, height: 465, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1093, y: 38, width: 142, height: 228, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1093, y: 274, width: 142, height: 228, rotation: 0, imageRotation: 0 }          
        ],
    },

    {
        id: "la-07-h0v7-05",
        name: "LA 05 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_05.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 138, y: 56, width: 265, height: 428, rotation: 0, imageRotation: 0 },            
            { id: "2", x: 410, y: 56, width: 129, height: 210, rotation: 0, imageRotation: 0 },
            { id: "3", x: 410, y: 274, width: 129, height: 210, rotation: 0, imageRotation: 0 },
            { id: "4", x: 821, y: 56, width: 276, height: 428, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1105, y: 56, width: 102, height: 138, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1105, y: 202, width: 102, height: 137, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1105, y: 347, width: 102, height: 137, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h0v7-06",
        name: "LA 06 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_06.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 143, y: 59, width: 260, height: 420, rotation: 0, imageRotation: 0 },
            { id: "2", x: 411, y: 273, width: 125, height: 207, rotation: 0, imageRotation: 0 },
            { id: "3", x: 411, y: 59, width: 125, height: 205, rotation: 0, imageRotation: 0 },
            { id: "4", x: 850, y: 42, width: 160, height: 228, rotation: 0, imageRotation: 0 },
            { id: "5", x: 850, y: 278, width: 160, height: 227, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 42, width: 160, height: 228, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1018, y: 278, width: 160, height: 227, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h0v7-07",
        name: "LA 07 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_07.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 123, width: 187, height: 295, rotation: 0, imageRotation: 0 },
            { id: "2", x: 195, y: 123, width: 187, height: 295, rotation: 0, imageRotation: 0 },
            { id: "3", x: 390, y: 123, width: 186, height: 295, rotation: 0, imageRotation: 0 },
            { id: "4", x: 584, y: 123, width: 186, height: 295, rotation: 0, imageRotation: 0 },
            { id: "5", x: 778, y: 123, width: 186, height: 295, rotation: 0, imageRotation: 0 },
            { id: "6", x: 972, y: 123, width: 186, height: 295, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1166, y: 123, width: 186, height: 295, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h0v7-08",
        name: "LA 08 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_08.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 42, y: 35, width: 304, height: 469, rotation: 0, imageRotation: 0 },
            { id: "2", x: 354, y: 35, width: 304, height: 469, rotation: 0, imageRotation: 0 },
            { id: "3", x: 665, y: 35, width: 304, height: 469, rotation: 0, imageRotation: 0 },
            { id: "4", x: 976, y: 35, width: 162, height: 231, rotation: 0, imageRotation: 0 },
            { id: "5", x: 976, y: 274, width: 162, height: 231, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1146, y: 35, width: 164, height: 231, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1146, y: 274, width: 164, height: 231, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h0v7-09",
        name: "LA 09 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_09.png",
        size: [1352, 541],
        style: {},
        slots: [        
            { id: "1", x: 64, y: 0, width: 178, height: 267, rotation: 0, imageRotation: 0 },
            { id: "2", x: 64, y: 275, width: 178, height: 266, rotation: 0, imageRotation: 0 },
            { id: "3", x: 250, y: 0, width: 177, height: 267, rotation: 0, imageRotation: 0 },
            { id: "4", x: 250, y: 275, width: 177, height: 266, rotation: 0, imageRotation: 0 },
            { id: "5", x: 435, y: 0, width: 177, height: 267, rotation: 0, imageRotation: 0 },
            { id: "6", x: 435, y: 275, width: 177, height: 266, rotation: 0, imageRotation: 0 },
            { id: "7", x: 812, y: 0, width: 388, height: 541, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h0v7-10",
        name: "LA 10 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_10.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 185, y: 58, width: 294, height: 425, rotation: 0, imageRotation: 0 },
            { id: "2", x: 794, y: 274, width: 142, height: 208, rotation: 0, imageRotation: 0 },
            { id: "3", x: 794, y: 58, width: 142, height: 208, rotation: 0, imageRotation: 0 },
            { id: "4", x: 944, y: 274, width: 141, height: 208, rotation: 0, imageRotation: 0 },
            { id: "5", x: 944, y: 58, width: 141, height: 208, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1093, y: 274, width: 141, height: 208, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1093, y: 58, width: 141, height: 208, rotation: 0, imageRotation: 0 }
        ],
    }
];